import { apiFetch } from "@/lib/api-client";
import { insights } from "@duress/shared";
import type { client } from "@duress/shared";

export async function getIndustries(
  month: string | null,
  region: client.Region,
): Promise<insights.IndustriesResponse> {
  const params = new URLSearchParams({ region });
  if (month) params.set("month", month);
  return apiFetch(`/insights/industries?${params.toString()}`, insights.IndustriesResponseSchema);
}

export async function getBenchmark(
  clientId: string,
  month: string | null,
): Promise<insights.BenchmarkResponse> {
  const qs = month ? `?month=${encodeURIComponent(month)}` : "";
  return apiFetch(
    `/insights/benchmark/${encodeURIComponent(clientId)}${qs}`,
    insights.BenchmarkResponseSchema,
  );
}
